import React from 'react'
import './SmallFooter.css'
function SmallFooter() {
  return (
      <div>
    <div className='smallFoter'>@ModernLotery</div>
    </div>
  )
}

export default SmallFooter